import * as a from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/Calendar.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(t, { ref: r, ...o, weights: n }));
e.displayName = "CalendarIcon";
const s = e;
export {
  s as Calendar,
  e as CalendarIcon
};
